"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToTop = exports.scrollToElement = exports.moveFocus = void 0;
var ScrollMethods = _interopRequireWildcard(require("./scroll"));
var _function = require("./type-checks/function");
var _object = require("./type-checks/object");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Moves focus to selected element
 *
 * @name scrollToElement
 * @param {Object} elem HTML Element to scroll to
 */

const moveFocus = (elem, setup) => {
  let result = {
    focused: false,
    hasSetup: false
  };
  if (elem && (0, _function.isFunction)(elem.focus)) {
    const hasSetup = (0, _object.isObject)(setup);
    elem.focus(hasSetup ? setup : {});
    result = {
      focused: true,
      hasSetup
    };
  }
  return result;
};

/**
 * Scroll element to top of viewport
 *
 * @name scrollToElement
 * @param {Object} elem HTML Element to scroll to
 */
exports.moveFocus = moveFocus;
const scrollToElement = function (elem) {
  let setup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if ((0, _function.isFunction)(elem.scrollIntoView)) {
    if (setup?.disableMoveFocus !== true) {
      ScrollMethods.moveFocus(elem, {
        preventScroll: true
      });
    }
    elem.scrollIntoView();
  }
};

/**
 * Scroll to the top of a web view
 *
 * @name scrollToTop
 */
exports.scrollToElement = scrollToElement;
const scrollToTop = () => {
  const body = document.querySelector("body");
  if (body && (0, _function.isFunction)(body.scrollIntoView)) {
    ScrollMethods.moveFocus(body, {
      preventScroll: true
    });
    body.scrollIntoView();
  } else {
    window.scrollTo({
      top: 0
    });
  }
};
exports.scrollToTop = scrollToTop;